// @ts-strict-ignore
import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { API } from '@shared/types/api';
import { Trigger } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { AuditTagList } from './AuditTagList';
import { AuditTagModal } from './AuditTagModal';

interface Props {
  component: API.AuditTagComponent;
  tags: string[];
  trigger: Trigger;
  anchorName: string;
  onChange(selectedTags: string[]): void;
  isReadOnly?: boolean;
}

export function WorkflowAuditTag({
  component,
  tags,
  trigger,
  onChange,
  isReadOnly,
  anchorName,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const tagList = !isEmpty(tags) && (
    <View row wrap shrinkWrap style={{ maxWidth: '100%' }} paddingBottom={1}>
      <AuditTagList tagOptions={component?.options} tags={tags} />
    </View>
  );

  return (
    <>
      <View paddingBottom={2}>
        <MBTextBody1 color={colors.foregroundActive}>{component?.label}</MBTextBody1>
      </View>
      <View row paddingBottom={1}>
        <AuditTagModal
          anchorName={anchorName}
          onChange={onChange}
          trigger={trigger}
          label={i18n('card.blocks.question.answerButtonLabel')}
          isMultiselect={component.multiselect}
          tagOptions={component.options.filter(option => !option.archived)}
          tags={tags}
          isReadOnly={isReadOnly}
        >
          {tagList}
        </AuditTagModal>
      </View>
    </>
  );
}
